<template>
  <div id="Employee" class="view">
    <div class="company_title">
      <h3 v-text="company.name"></h3>
      <button class="btn btn-tiny btn-yellow"
        :disabled="company.id === user.company.id"
        @click="$store.dispatch('user/setDefault', company.ref)">Velg som standard</button>
    </div>
    <h4>Forlat nåværende firma?</h4>
    <p>Om du forlater firmaet kan du forsatt kobles tilbake ved å taste inn bedriftskoden, og deretter godkjennes av eier.</p>
    <button class="btn btn-red" @click="leaveCompany">Forlat firma</button>
    <Loader :visible="loading" />
  </div>
</template>

<script>

export default {
  name: 'Employee',
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    user () {
      return this.$store.state.user.data
    },
    company () {
      return this.$store.state.user.company
    },
  },
  methods: {
    leaveCompany () {
      if (this.loading) return
      this.loading = true
      this.$toasted.show('Er du sikker at du vil forlate firma?', {
        theme: 'toasted-primary',
        duration: null,
        closeOnSwipe: false,
        action: [{
          text: 'Nei',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
            this.loading = false
          },
        }, {
          text: 'Ja!',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
            this.$store.dispatch('user/leaveCompany', this.company.id).then(() => {
              this.loading = false
              this.$router.go(-1)
            }).catch((error) => {
              console.warn(error.message)
            })
          },
        }],
      })
    },
  },
}
</script>

<style lang="scss">
#Employee {
  align-items: flex-start;
  justify-content: flex-start;
}
</style>

